import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function RSVPFormBuilder() {
  return (
    <div className="dashboard-section">
      <h1>
        RSVP Form Builder
        <InfoButton
          title="RSVP Form Builder"
          content={
            <div>
              <p>
                Get even more control. You can customise the RSVP form to collect details like dietary requirements, 
                tag guests by group — family, friends, or even "needs accommodation" — and send different questions to different sets of guests.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Customize form fields and questions</li>
                <li>Collect dietary requirements and special requests</li>
                <li>Tag guests by groups (family, friends, work, etc.)</li>
                <li>Send different questions to different guest lists</li>
                <li>Track responses in real-time</li>
                <li>Generate shareable RSVP link</li>
              </ul>
              <p>
                It's RSVP management made smarter, smoother, and way less stressful.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={2} />
    </div>
  )
}

export default RSVPFormBuilder
